<div class="user-chooser-container">
  <pt-input-label
    *ngIf='label'
    [inputId]='inputId'
    [label]='label'
    style='display: contents'
  ></pt-input-label>

  <div class='form-control form-control-sm ng-select-multiple-control ng-select-multiple-control-lg mb-3'>
    <ng-select
      [(ngModel)]="dialogSelectedMembers"
      [closeOnSelect]="false"
      [disabled]="dialogMembers.length === 0"
      [hideSelected]="false"
      [id]='inputId'
      [items]='dialogMembers'
      [multiple]='true'
      [readonly]='disabled'
      [searchFn]="customSearchFn"
      bindLabel='{{options?.bindLabel}}'
      bindValue='{{options?.bindValue}}'>
      <ng-template ng-multi-label-tmp let-items='items' let-clear='clear' let-index='index'>
          <div class='ng-value' *ngFor='let item of items | slice:0:2'>
            <span class='ng-value-label ng-value-label-custom text-ellipsis'>{{$any(item).fullName  }}</span>
            <span class='ng-value-icon right' (click)='clear(item)' aria-hidden='true'>×</span>
          </div>

          <div class='ng-value' *ngIf='items.length > 2'>
                <span class='ng-value-label'>{{ items.length - 2 }} <span
                  class="text-lowercase">{{ "LABELS.MORE" | translate }}</span>...</span>
          </div>
      </ng-template>

      <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
        <span [innerHTML]="item.fullName | highlight: search"></span>
      </ng-template>

    </ng-select>

    <button (click)='addMember()' [disabled]="dialogSelectedMembers.length === 0"
            class='btn btn-outline-dark btn-sm'
            type='button'>
      {{ 'BUTTON.ADD' | translate }}
    </button>
  </div>
</div>


<ag-grid-angular
  (gridReady)="onGridReady($event)"
  *ngIf='gridOptions && columnsDef && columnsDef.length > 0'
  [columnDefs]='columnsDef'
  [gridOptions]='gridOptions'
  [rowData]='selectedMembers'
  class='ag-theme-balham w-100'
  style='height: 200px'>
</ag-grid-angular>


<ng-template #actionCol let-node>
  <pt-icon (click)='removeMember(node.row)' [key]='IconRemove' class='cursor-pointer'></pt-icon>
</ng-template>

<ng-template #nameCol let-node>
  {{ node.row.fullName }}
</ng-template>

<ng-template #roleCol let-node>
  <input (click)='$event.stopPropagation()'
         (ngModelChange)="changeRole(node.row, $event)"
         [maxLength]='128'
         [ngModel]="node.row.role"
         autocomplete='off'
         class='form-control form-control-sm'
         type='text'>
</ng-template>
